<template>
  <template v-if="question?.status !== 'READ_ONLY'">
      <div :class="{'mb-4':!errorAdd1, inputContainer:true}" v-bind="$attrs">
      <input
          id="address1"
          class="quill-question-input"
          :disabled="disabled"
          @blur.stop="emitChange('address1');$emit('user-interaction');validate(question, $event.target.value);"
          :class="{
        invalid: errorAdd1 && hasBeenInteractedWith,
      }"
          ref="autocompleteInput"
          type="text"
          placeholder=" "
          v-model="address1"
          @input="restrictChars('address1')"
          @keydown.enter.prevent.stop="emitChange('address1');$emit('user-interaction')"
      />
      <span class="quill-question-placeholder">{{ question?.placeholder ||  question?.prompt}}</span>
    </div>
    <div v-if="errorAdd1" class="mb-4">
      <span id="errorAdd1" class="subtext pt-2" :class="{errorMessage: hasBeenInteractedWith}">{{ errorAdd1 }}</span>
    </div>
    <div :class="{'mb-4':!errorAdd2, inputContainer:true}" v-if="Object.keys(address2Config).length">
      <input
          id="address2"
          class="quill-question-input"
          type="text"
          :disabled="disabled"
          :class="{
        invalid: errorAdd2 && hasBeenInteractedWith,
      }"
          placeholder=" "
          v-model="address2"
          @input="restrictChars('address2')"
          @blur="emitChange('address2');$emit('user-interaction');validate(address2Config, $event.target.value);"
          @keydown.enter.prevent.stop="emitChange('address2');$emit('user-interaction')"
      />
      <span class="quill-question-placeholder">{{ address2Config?.placeholder ||  address2Config?.prompt}}</span>
    </div>
    <div v-if="errorAdd2" class="mb-4">
      <span id="errorAdd2" class="subtext d-block pt-2" :class="{errorMessage: hasBeenInteractedWith}">{{ errorAdd2 }}</span>
    </div>
    <div :class="{'mb-4':!errorCity, inputContainer:true}">
      <input
          id="city"
          class="quill-question-input"
          :disabled="disabled"
          :class="{
        invalid: errorCity && hasBeenInteractedWith,
      }"
          type="text"
          placeholder=" "
          v-model="city"
          @input="restrictChars('city')"
          @blur.stop="emitChange('city');$emit('user-interaction');validate(cityFieldConfig, $event.target.value);"
          @keydown.enter.prevent.stop="emitChange('city');$emit('user-interaction')"
      />
      <span class="quill-question-placeholder">{{cityFieldConfig?.placeholder || 'City'}}</span>
    </div>
    <div v-if="errorCity" class="mb-4">
      <span id="errorCity" class="subtext d-block pt-2" :class="{errorMessage: hasBeenInteractedWith}">{{ errorCity }}</span>
    </div>

    <span v-if="(state || zip) && question?.type === 'address'" id="stateAndZip" class="fw-bold d-inline-block">{{ state }}, {{ zip }}</span>
    <div class="row" v-if="question?.type !== 'address'">
      <div class="col">
        <div :class="{inputContainer:true}">
          <input
              id="state"
              class="quill-question-input"
              :disabled="disabled"
              :class="{
        invalid: errorState && hasBeenInteractedWith,
      }"
              type="text"
              placeholder=" "
              v-model="state"
              @input="restrictChars('state')"
              @blur.stop="emitChange('state');$emit('user-interaction');validate(stateConfig, $event.target.value);"
              @keydown.enter.prevent.stop="emitChange('state');$emit('user-interaction')"
          />
          <span class="quill-question-placeholder">{{stateConfig?.placeholder || 'State'}}</span>
        </div>
        <div v-if="errorState" class="mb-4">
          <span id="errorState" class="subtext d-block" :class="{errorMessage: hasBeenInteractedWith}">{{ errorState }}</span>
        </div>
      </div>
      <div class="col">
        <div :class="{ inputContainer:true}">
          <input
              id="zip"
              class="quill-question-input"
              :disabled="disabled"
              maxlength="5"
              :class="{
        invalid: errorZip && hasBeenInteractedWith,
      }"
              type="text"
              placeholder=" "
              v-model="zip"
              @input="restrictChars('zip')"
              @blur.stop="emitChange('zip');$emit('user-interaction');validate(zipConfig, $event.target.value);"
              @keydown.enter.prevent.stop="emitChange('zip');$emit('user-interaction')"
          />
          <span class="quill-question-placeholder">{{zipConfig?.placeholder || 'Zip'}}</span>
        </div>
        <div v-if="errorZip" class="mb-4">
          <span id="errorZip" class="subtext d-block" :class="{errorMessage: hasBeenInteractedWith}">{{ errorZip }}</span>
        </div>
      </div>
    </div>
    <slot name="helptext"
          :isConfirm="!disableConfirm && (question?.value && question?.prefilled) && (!errorAdd1 && errorAdd2 && errorCity && errorState && errorZip)"
          :confirmCb="() => {$emit('user-interaction'); $emit('confirm')}"
    ></slot>
  </template>
  <div v-else>
    <ReadOnly
        :question="question"
        :value="address1 ? `${address1}`:'-'"
        :forcePromptPlaceholder="forcePromptPlaceholder"
    />
    <ReadOnly
        v-if="Object.keys(address2Config).length"
        :question="address2Config"
        :value="address2 ? `${address2}`:'-'"
        :forcePromptPlaceholder="forcePromptPlaceholder"
    />
    <ReadOnly
        :question="cityFieldConfig"
        :value="city ? `${city}`:'-'"
        :forcePromptPlaceholder="forcePromptPlaceholder"
    />
    <ReadOnly
        :question="stateConfig"
        :value="state ? `${state}`:'-'"
        :forcePromptPlaceholder="forcePromptPlaceholder"
    />
    <ReadOnly
        :question="zipConfig"
        :value="zip ? `${zip}`:'-'"
        :forcePromptPlaceholder="forcePromptPlaceholder"
    />
  </div>


</template>

<script>
import ReadOnly from "@/components/waffle/components/form-components/ReadOnly.vue";
import {debounce} from "@/components/waffle/utils/debouce";

export default {
  components: {ReadOnly},
  setup(props, context){
    const emitConfirm = debounce(() => context.emit('confirm'),300)
    // const emitConfirm = () =>{
    // }

    return {
      emitConfirm
    }
  },
  props: {
    forcePromptPlaceholder:Boolean,
    modelValue: {
      type: Object,
    },
    fields: {
      type: Array,
      required: true,
    },
    question: {
      type: Object,
      required: true,
    },
    skipEagerValidation: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    hideSubText: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    hasBeenInteractedWith:Boolean,
    disabled: Boolean,
    disableConfirm:Boolean,
  },
  emits: ["address-change", "address-error",'confirm','user-interaction'],
  data() {
    return {
      autocomplete: null,
      address1: "",
      address2: "",
      city: "",
      state: "",
      zip: "",
      errorAdd1: "",
      errorAdd2: "",
      errorCity: "",
      errorState: "",
      errorZip: "",
    };
  },
  computed: {
    cityFieldConfig() {
      const cityFields = ["QTE_ResidenceCity","QTE_PRP_City","QTE_PriorResidenceCity","QTE_PRP_MailingCity","QTE_MailCity","QTE_PRP_BillingCity"]
      return (
        (this.fields || []).find((el) => cityFields.includes(el.name) || new RegExp('QTE_VEH_\\d+_LeaseCity').test(el.name)) || {}
      );
    },
    address2Config() {
      const address2Fields =["QTE_PRP_MailingAddress2","QTE_ResidentialUnitNumber","QTE_PRP_Address2"]
      return (
        (this.fields || []).find(
          (el) => address2Fields.includes(el.name)) || {}
      );
    },
    zipConfig() {
      const zipFields = ["QTE_ResidenceZip","QTE_PRP_ZipCode","QTE_PriorResidenceZip","QTE_PRP_MailingZipCode",'QTE_MailZip',"QTE_PRP_BillingZip"]
      return (
        (this.fields || []).find((el) => zipFields.includes(el.name) || new RegExp('QTE_VEH_\\d+_LeaseZip').test(el.name)) || {}
      );
    },
    stateConfig() {
      const stateFields = ["QTE_PRP_MailingState", "QTE_State", "QTE_PRP_State", "QTE_PriorResidenceState","QTE_MailState","QTE_PRP_BillingState"]
      return (this.fields || []).find((el) => stateFields.includes(el.name) || new RegExp('QTE_VEH_\\d+_LeaseState').test(el.name)) || {};
    },
  },
  mounted() {
    if (this.question.value) {
      this.address1 = this.question.value;
    }
    if (this.cityFieldConfig.value) {
      this.city = this.cityFieldConfig.value;
    }
    if (this.address2Config.value) {
      this.address2 = this.address2Config.value;
    }
    if (this.stateConfig.value) {
      this.state = this.stateConfig.value;
    }
    if (this.zipConfig.value) {
      this.zip = this.zipConfig.value;
    }

    if (!this.skipEagerValidation) {
      this.validate(this.question, this.address1);
      this.validate(this.cityFieldConfig, this.city);
      if(this.address2Config){
        this.validate(this.address2Config, this.address2);
      }
      this.validate(this.stateConfig, this.state);
      this.validate(this.zipConfig, this.zip);
    }
    this.initAutocomplete();
  },
  watch: {
    address1(newVal) {
      this.validate(this.question, newVal);
//    This logic is needed to resolve autosuggestion issue for address field.
//    Due to low Z-index for autosuggestion dropdown list, it was not visible in UI
      if (document.getElementsByClassName("pac-container") && document.getElementsByClassName     ("pac-container").length > 0 ) {
        let pacContainer = document.getElementsByClassName("pac-container");
        if (pacContainer &&  document.getElementById("address1")) {
          for (let index = 0; index < pacContainer.length; index++) {
            pacContainer[index].style.zIndex  = "1200";
          }
        }
      }
    },
    address2(newVal) {
      this.validate(this.address2Config, newVal);
    },
    city(newVal) {
      this.validate(this.cityFieldConfig, newVal);
    },
    state(newVal) {
      this.validate(this.stateConfig, newVal);
    },
    zip(newVal) {
      this.validate(this.zipConfig, newVal);
    },
  },
  methods: {
    validate(config, value) {
      const mapping = {
        QTE_ResidentialStreetAddress: "errorAdd1",
        QTE_ResidentialUnitNumber: "errorAdd2",
        QTE_ResidenceCity: "errorCity",
        QTE_State: "errorState",
        QTE_ResidenceZip: "errorZip",
        QTE_PRP_StreetAddress: "errorAdd1",
        QTE_PRP_Address2: "errorAdd2",
        QTE_PRP_City: "errorCity",
        QTE_PRP_State: "errorState",
        QTE_PRP_ZipCode: "errorZip",
        QTE_PriorResidenceAddress: "errorAdd1",
        QTE_PriorResidenceCity: "errorCity",
        QTE_PriorResidenceState: "errorState",
        QTE_PriorResidenceZip: "errorZip",
        QTE_MailStreetAddress: "errorAdd1",
        QTE_MailCity: "errorCity",
        QTE_MailState: "errorState",
        QTE_MailZip: "errorZip",
        QTE_PRP_MailingStreetAddress: "errorAdd1",
        QTE_PRP_MailingAddress2: "errorAdd2",
        QTE_PRP_MailingCity: "errorCity",
        QTE_PRP_MailingState: "errorState",
        QTE_PRP_MailingZipCode: "errorZip",
        QTE_PRP_BillingStreetAddress: "errorAdd1",
        QTE_PRP_BillingCity: "errorCity",
        QTE_PRP_BillingState: "errorState",
        QTE_PRP_BillingZip: "errorZip"
      };

      const dynamicMappings =  {
        'QTE_VEH_\\d+_LeaseAddress':'errorAdd1',
        'QTE_VEH_\\d+_LeaseCity':'errorCity',
        'QTE_VEH_\\d+_LeaseState':'errorState',
        'QTE_VEH_\\d+_LeaseZip':'errorZip'
      }
      const stateField =mapping[config.name] || dynamicMappings[Object.keys(dynamicMappings).find(k => new RegExp(k).test(config.name))]
      if(value.length < 5 && stateField === 'errorZip'){
        this[stateField] = 'Zip codes should be 5 digits'
        this.$emit("address-error", {
          field: config.name,
          hasError: true,
        });
        return
      }
      if (config.required && !value) {
        this[stateField] = "Required";
        this.$emit("address-error", {
          field: config.name,
          hasError: true,
        });
      } else {
        this[stateField] = "";
        this.$emit("address-error", {
          field: config.name,
          hasError: false,
        });
      }
    },
    emitChange(type){
      const shouldEmitConfirm = this.address1 && (this.address2 && Object.keys(this.address2Config).length || true) && this.city && this.state && this.zip;
      switch(type){
        case 'address1':
          if (!this.errorAdd1) {
            this.address1 = this.address1.trim()
            this.$emit("address-change", {
              [this.question.name]: this.address1,
              [this.address2Config.name]: this.address2,
              [this.cityFieldConfig.name]: this.city,
              [this.stateConfig.name]: this.state,
              [this.zipConfig.name]: this.zip
            });
            if(shouldEmitConfirm){
              this.emitConfirm()
            }
          }
          break;

        case 'address2':
          if (!this.errorAdd2) {
            this.address2 = this.address2.trim()
            this.$emit("address-change", {
              [this.address2Config.name]: this.address2
            });
            if(shouldEmitConfirm){
              this.emitConfirm()
            }
          }
          break;
        case 'city':
          if (!this.errorCity) {
            this.city=this.city.trim()
            this.$emit("address-change", {
              [this.cityFieldConfig.name]: this.city
            });
            if(shouldEmitConfirm){
              this.emitConfirm()
            }
          }
          break;
        case 'state':
          if (!this.errorState) {
            this.state=this.state.trim()
            this.$emit("address-change", {
              [this.stateConfig.name]: this.state
            });
            if(shouldEmitConfirm){
              this.emitConfirm()
            }
          }
          break;
        case 'zip':
          if (!this.errorZip) {
            this.zip=this.zip.trim()
            this.$emit("address-change", {
              [this.zipConfig.name]: this.zip
            });
            if(shouldEmitConfirm){
              this.emitConfirm()
            }
          }
          break;
      }
    },
    restrictChars(type){
      const regex = {
        city:/[^a-zA-Z.'\- ]/g,
        address2:/[^a-zA-Z0-9.,'# ]/g,
        address1:/[^a-zA-Z0-9,.'# ]/g,
        zip:/[^0-9]{1,5}/g,
        state:/[^a-zA-Z]/g
      }
      this[type] = this[type]?.replaceAll(regex[type],'')
    },
    setupAutocomplete(){
      // eslint-disable-next-line no-undef
      const geocoder = new google.maps.Geocoder();

      geocoder.geocode({ address: `${this.zip} USA` }, (results, status) => {
        let lat = 0,
            lng = 0;
        if (status === "OK") {
          lat = results[0].geometry.location.lat();
          lng = results[0].geometry.location.lng();
        } else {
          console.info(
              "Unable to retrieve lat/lng for this ZIP code. Disabling look up"
          );
          return;
        }
        // eslint-disable-next-line no-undef
        const center = new google.maps.LatLng(lat, lng);
        // eslint-disable-next-line no-undef
        const circle = new google.maps.Circle({
          center: center,
          radius: 10000,
        });

        const options = {
          bounds: circle.getBounds(),
          componentRestrictions: { country: ["us"] },
          types: ["address"],
          strictBounds: true,
          fields: ["address_components"],
        };
        if(!this.zip){
          delete options.bounds
        }
        //eslint-disable-next-line no-undef
        this.autocomplete = new google.maps.places.Autocomplete(
            this.$refs.autocompleteInput,
            options
        );

        // eslint-disable-next-line no-undef
        google.maps.event.addListener(
            this.autocomplete,
            "place_changed",
            () => {
              const place = {
                address_components: [],
                ...this.autocomplete.getPlace(),
              };

              let street_number = "";
              let street_name = "";
              let city = "";
              let state = ""
              let zip=""

              // eslint-disable-next-line no-unused-vars
              place.address_components.forEach((el) => {
                // console.log(el);
                if (el.types?.some((t) => t === "street_number")) {
                  street_number = el.short_name;
                }

                if (el.types?.some((t) => t === "route")) {
                  street_name = el.short_name;
                }

                if (el.types?.some((t) => t === "locality")) {
                  city = el.short_name;
                }
                if (el.types?.some((t) => t === "administrative_area_level_1")) {
                  state = el.short_name;
                }
                if (el.types?.some((t) => t === "postal_code")) {
                  zip = el.short_name;
                }
              });
              this.address1 = `${street_number} ${street_name}`;
              this.city = city;
              this.state = state;
              this.zip= zip;
              this.$nextTick(() => {
                this.emitChange('address1')
                this.emitChange('city')
                this.emitChange('state')
                this.emitChange('zip')
                // this.$emit('update:modelValue',  this.address1 )
                this.emitConfirm()
              })

              return false;
            }
        );
      });
    },
    initAutocomplete() {
        if(!window.hasGoogleLoaded){
          let googleAPIKey = process.env.VUE_APP_GOOGLE_KEY;
          let  element = document.createElement("script");
          window.loadGoogle = () => {
            console.log('google has loaded successfully')
            window.hasGoogleLoaded = true;
            this.setupAutocomplete()
          }
          element.src = 'https://maps.googleapis.com/maps/api/js?v=3.exp&callback=loadGoogle&sensor=false&libraries=places&key=' + googleAPIKey;
          element.id='google'
          document.head.appendChild(element);
        }
      else{
        this.setupAutocomplete()
      }
    },
  },
  beforeUnmount() {
    // eslint-disable-next-line no-undef
    if (this.autocomplete && window.hasGoogleLoaded) {
      // eslint-disable-next-line no-undef
      google.maps.event.clearInstanceListeners(this.autocomplete);
    }
  },
};
</script>
<style scoped lang="scss">
.subtext {
  font-size: 12px;
  color: #757575;
}
.helpText{
  font: normal normal normal 12px/18px Roboto;
  letter-spacing: 0px;
  color: #757575;
}
.errorMessage {
  color: #BB0000
}

.gap {
  margin-right: 10px;
}

.quill-question {

    div.inputContainer {
    position: relative;
    max-height: 50px;
    min-height: 50px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    cursor: pointer;

     .quill-question-input {
      box-sizing: border-box;
      border: 1px solid #ccc;
      border-radius: 3px;
      padding: 8px 12px;
      width: 100%;
      font-size: 16px;
      font-weight: bold;
      background: transparent;
      min-height: 100%;
      @media screen and (max-width: 768px) {
        min-width: auto !important;
        // flex: 0 0 45% !important;
      }

      &:has(~.question-type-unknown) {
        border-color: #BB0000;
      }

      &:hover, &:focus {
        outline: none;
        border: 2px solid #212121;
        box-shadow: none;
        padding: 15px 5px;
      }

      &:disabled {
        background-color: #EEEEEE;
      }
    }

    .quill-question-placeholder {
      position: absolute;
      padding: 10px 16px;
      line-height: 2em;
      top: 0;
      left: 0;
      color: #757575;
      font-size: 16px;
      pointer-events: none;
      transform: scale(1);
      transition: .26s all ease;
    }
  }
}

/*TODO convert to scss*/


.quill-question  div.inputContainer .quill-question-input:focus,
.quill-question  div.inputContainer .quill-question-input:not(.radio,:placeholder-shown) {
  padding: 25px 8px 8px 12px;
}

.quill-question  div.inputContainer .quill-question-input:focus + .quill-question-placeholder,
.quill-question  div.inputContainer .quill-question-input:not(.radio,:placeholder-shown) + .quill-question-placeholder {
  font-size: 12px;
  padding: 6px 8px 12px 12px !important;
}



.placeholder-adjusment + .quill-question-placeholder {
  font-size: 12px !important;
  padding-top:6px !important;
  padding-right: 8px !important;
  padding-bottom:12px !important;
  padding-left:12px ;
}


.form-floating > .form-control:focus ~ label.form-label-text, .form-floating > .form-control:focus ~ label {
  font-size: 12px;
  color: #484848;
  padding-top: 1rem;
}

.form-control-disabled:hover {
  border: none;
}

.form-control-enabled:hover {
  border: 2px solid #212121
}

.invalid {
  border: 1px solid #BB0000 !important;

  &:hover, &:focus, &:focus-within {
    border: 2px solid #BB0000 !important;
  }
}

</style>
